import React, {useState} from "react";
import {
  Box,
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Text,
  Modal,
  ModalCloseButton,
  ModalOverlay,
  ModalHeader,
  ModalContent,
  ModalBody,
  ModalFooter,
  useToast
} from "@chakra-ui/react";
import { cqAPI } from "../../lib/Auth";
import ChangePasswordComponent from "./ChangePasswordComponent";
import { useNavigate } from "react-router-dom";

/**
 * Change Password Modal
 * Allows changing password when clicking on a password reset link
 */
export default function ChangePassword() {
  const navigate = useNavigate();
  const toast = useToast();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertStatus, setAlertStatus] = useState("error");
  const [alertMessage, setAlertMessage] = useState("");
  const [password, setPassword] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const showAlert = (message, status = "error") => {
    setAlertMessage(message);
    setAlertStatus(status);
    setIsAlertVisible(true);
  }

  const processChange = (response) => {
    const {msg} = response;
    if (response.type === "ok") {
      const successMessage = msg || "Password changed successfully";
      toast({
        title : successMessage,
        status : 'success',
        isClosable: true,
      })
      setSubmitDisabled(true);
      navigate('/?bid=');
    } else {
      showAlert(msg || "Password reset failed");
    }
  };

  const changePassword = async (event) => {
    event.preventDefault();
    setIsAlertVisible(false);
    try {
      const response = await cqAPI.post("/profile", {
        ...(password ? {password} : {}),
      });
      processChange(response);
    } catch (error) {
      showAlert(`Error during password reset: ${error.message}`)
    }
  };

  return (
    <Modal isOpen onClose={() => setIsAlertVisible(false)}>
      <ModalOverlay/>
      <ModalContent>
        <form onSubmit={changePassword}>
          {isAlertVisible && (
            <Alert status={alertStatus}>
              <AlertIcon/>
              <Box flex="1">
                <AlertTitle>
                  <Text casing="capitalize">{alertStatus}</Text>
                </AlertTitle>
                <AlertDescription display="block">
                  {alertMessage}
                </AlertDescription>
              </Box>
            </Alert>
          )}
          <ModalHeader>
            Change Password
          </ModalHeader>
          <ModalCloseButton onClick={() => navigate('/')}/>
          <ModalBody>


            <ChangePasswordComponent
              isVisible
              onPasswordChange={(value) => setPassword(value)}
              onIsInvalidChange={(value) => setSubmitDisabled(value)}
              validationErrors={[]}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              width="full"
              mt={4} type="submit"
              colorScheme="teal"
              isDisabled={submitDisabled}
            >
              Change password
            </Button>
          </ModalFooter>
        </form>

      </ModalContent>
    </Modal>
  );

}
